import React, { useContext, useEffect, useState } from 'react';
import "../../styles/admin/Menu.css";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { TbMessageDots } from "react-icons/tb";
import { FaUserTie } from "react-icons/fa";
import { MdCasino, MdDeleteOutline, MdOutlineAdminPanelSettings, MdOutlineAnalytics, MdOutlineGroupAdd } from "react-icons/md";
import { LuCalendarClock } from "react-icons/lu";
import { RiFolderHistoryLine } from "react-icons/ri";
import { TbPigMoney } from "react-icons/tb";
import { FaQuestion } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { FcDataConfiguration } from "react-icons/fc";
import { IoPersonAddSharp } from "react-icons/io5";
import { Link } from 'react-router-dom';
import AgentContext from '../../context//admin/Agent.tsx';
import { BiWorld } from "react-icons/bi";
import { formatNumbers } from '../../helpers/functions.tsx';
import { CLOSING_LINE_ANALYTICS_ENABLED } from '../../helpers/closingLineAnalysis.ts';
import { logUserActivity } from '../../services/player/LoginService.tsx';
import { canAccessAdminCasino } from '../../services/player/VimplayService.tsx';
import { useUser } from '../../context/UserContext.tsx';

type MenuStatValueProps = {
    loading: boolean;
    skeletonClassName?: string;
    children: React.ReactNode;
};

const MenuStatValue = ({ loading, skeletonClassName = 'menu-stat-skeleton', children }: MenuStatValueProps) => {
    if (loading) {
        return (
            <span
                className={`rect-placeholder ${skeletonClassName}`}
                aria-hidden="true"
                role="presentation"
            />
        );
    }

    return <>{children}</>;
};

function MenuComponent() {

    const { user: currentUser, userIpData: userIpDataAdmin } = useUser();
    const [isMaster,] = useState(currentUser?.userType === 'masterAgent');
    const { playerActive, casinoAccounts, totalToday, loading, totalWeek, ensureSummary } = useContext(AgentContext)
    const weekTotal = totalWeek ?? 0;
    const todayTotal = totalToday ?? 0;
    const statsLoading = loading || totalWeek === null || totalToday === null;

    useEffect(() => {
        ensureSummary();
    }, [ensureSummary]);

    const sendingMessage = (e: any) => {
        if (e) {
            console.log("create");
        }
    }

    return (
        <div>
            <div className="mt-2">
                <div className='col-12 balance-container-admin'>
                    <span>My Balance</span>
                    <Link to="/billing" className="no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Billings", userIpDataAdmin)}>
                        <span className="fw-bold">$0</span>
                    </Link>
                </div>
                <div className="row mx-0 mt-1">
                    <div className="col-6 balance-container-admin">
                        <span>Week</span>
                        <Link to="/weekly-figures" className="no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Weekly Figures", userIpDataAdmin)}>
                            <MenuStatValue loading={statsLoading}>
                                <span className={`fw-bold ${weekTotal < 0 ? "negative" : weekTotal > 0 ? "positive" : ""}`}>
                                    $ {formatNumbers(weekTotal)}
                                </span>
                            </MenuStatValue>
                        </Link>
                    </div>
                    <div className="col-6 balance-container-admin">
                        <span>Today</span>
                        <MenuStatValue loading={statsLoading}>
                            <span className={`fw-bold ${todayTotal < 0 ? "negative" : todayTotal > 0 ? "positive" : ""}`}>
                                $ {formatNumbers(todayTotal)}
                            </span>
                        </MenuStatValue>

                    </div>
                </div>
                <div className="row mx-0 mt-2">
                    <div className="col-6 balance-container-admin">
                        <span>Active Accts</span>
                        <MenuStatValue loading={statsLoading} skeletonClassName="menu-stat-skeleton menu-stat-skeleton--count">
                            <span className="color-active-accts fw-bold">
                                {playerActive ?? 0}
                            </span>
                        </MenuStatValue>
                    </div>
                    <div className="col-6 balance-container-admin">
                        <span>Casino Active</span>
                        <MenuStatValue loading={statsLoading} skeletonClassName="menu-stat-skeleton menu-stat-skeleton--count">
                            <span className="color-active-accts fw-bold">
                                {casinoAccounts ?? 0}
                            </span>
                        </MenuStatValue>
                    </div>
                </div>

            </div>
            <div className="text-center mt-2">
                <div className="row row-cols-2 row-cols-lg-6 g-1">
                    <Link to="/weekly-figures" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Weekly Figures", userIpDataAdmin)}>
                        <div className="color-menu-admin">
                            <FaMoneyBillTrendUp className='icon-menu' />
                            <div className="menu-letters-admin">Weekly Figures</div>
                        </div>
                    </Link>
                    <Link to="/pendingBets" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Pending Bets", userIpDataAdmin)}>
                        <div className="color-menu-admin">
                            <LuCalendarClock className='icon-menu' />
                            <div className="menu-letters-admin">Pending Bets</div>
                        </div>
                    </Link>
                    <Link to="/messagingAdmin" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Messaging", userIpDataAdmin)}>
                        <div className="color-menu-admin" >
                            <TbMessageDots className='icon-menu' />
                            <div className="menu-letters-admin">Messaging</div>
                        </div>
                    </Link>
                    <Link to="/customerAdmin" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Customer Admin", userIpDataAdmin)}>
                        <div className="color-menu-admin">
                            <FaUserTie className='icon-menu' />
                            <div className="menu-letters-admin">Customer Admin</div>
                        </div>
                    </Link>
                    <div className="col">
                        <div className="color-menu-admin color-add" data-bs-toggle="modal" data-bs-target="#addCustomer">
                            <MdOutlineGroupAdd className='icon-menu' />
                            <div className="menu-letters-admin">Add Customer</div>
                        </div>
                    </div>
                    <Link to="/userIp" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View IP Tracker", userIpDataAdmin)}>
                        <div className="color-menu-admin color-add">
                            <BiWorld className='icon-menu' />
                            <div className="menu-letters-admin">IP Tracker</div>
                        </div>
                    </Link>

                    <Link to="/transactionHistory" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Transactions History", userIpDataAdmin)}>
                        <div className="color-menu-admin color-delete">
                            <RiFolderHistoryLine className='icon-menu' />
                            <div className="menu-letters-admin">Transactions History</div>
                        </div>
                    </Link>
                    <Link to="/deleteWagers" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Deleted Wagers", userIpDataAdmin)}>
                        <div className="color-menu-admin color-delete">
                            <MdDeleteOutline className='icon-menu' />
                            <div className="menu-letters-admin">Deleted Wagers</div>
                        </div>
                    </Link>

                    {isMaster && (
                        <Link to="/manager" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Agent Admin", userIpDataAdmin)}>
                            <div className="color-menu-admin color-billing">
                                <MdOutlineAdminPanelSettings className='icon-menu' />
                                <div className="menu-letters-admin">Agent Admin</div>
                            </div>
                        </Link>
                    )}
                    <Link to="/billing" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Billing", userIpDataAdmin)}>
                        <div className="color-menu-admin color-billing">
                            <TbPigMoney className='icon-menu' />
                            <div className="menu-letters-admin">Billing</div>
                        </div>
                    </Link>

                    <Link to="/frequentQuestions" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View FAQ", userIpDataAdmin)}>
                        <div className="color-menu-admin">
                            <FaQuestion className='icon-menu' />
                            <div className="menu-letters-admin">F.A.Q</div>
                        </div>
                    </Link>
                    <Link to="/bettingSetup" className="col no-link-admin">
                        <div className="color-menu-admin">
                            <FcDataConfiguration className='icon-menu' />
                            <div className="menu-letters-admin">Betting Setup</div>
                        </div>
                    </Link>
                    {canAccessAdminCasino(currentUser) && (
                        <Link to="/casino" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Casino", userIpDataAdmin)}>
                            <div className="color-menu-admin">
                                <MdCasino className='icon-menu' />
                                <div className="menu-letters-admin">Casino</div>
                            </div>
                        </Link>
                    )}
                    {CLOSING_LINE_ANALYTICS_ENABLED && isMaster && (
                        <Link to="/analytics" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Closing Line Analysis", userIpDataAdmin)}>
                            <div className="color-menu-admin">
                                <MdOutlineAnalytics className='icon-menu' />
                                <div className="menu-letters-admin">Analytics</div>
                            </div>
                        </Link>
                    )}
                </div>
            </div>

            {<div className="modal fade" id="addCustomer" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="container-title-addCustomer">
                            <h1 className="title-add-customer">Add Customer</h1>
                            <IoMdClose className='icon-modal' size={42} data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <Link to="/add-player" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Add Player", userIpDataAdmin)}>
                                <div className="p-3 opcion-add align-items-center" data-bs-dismiss="modal">
                                    <div className="d-flex flex-column">
                                        <IoPersonAddSharp className="icon-menu" />
                                        <div className="menu-letters-admin">Player</div>
                                    </div>
                                    <div className="col">
                                        <span className="body-add-customer">Add one or many players to an agent</span>
                                    </div>
                                </div>
                            </Link>
                            {currentUser?.userType === 'masterAgent' && (
                                <Link to="/register-an-agent" className="col no-link-admin" onClick={() => logUserActivity(currentUser!.userName, "View Add Agent", userIpDataAdmin)}>
                                    <div className="p-3 opcion-add align-items-center" data-bs-dismiss="modal">
                                        <div className="d-flex flex-column">
                                            <IoPersonAddSharp className="icon-menu" />
                                            <div className="menu-letters-admin">Agent</div>
                                        </div>
                                        <div className="col body-add-customer">
                                            <span className="">Add a new agent account. Agents have players under them (not agents).</span>
                                        </div>
                                    </div>
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </div>}
            {
                <div className="modal fade" id="menssaging" tabIndex={-1}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5">We value your feedback, thank you</h1>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="mb-3">
                                        <label htmlFor="recipient-name" className="col-form-label">Subject:</label>
                                        <input type="text" className="form-control" id="recipient-name" name="recipientName" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="message-text" className="col-form-label">Message:</label>
                                        <textarea className="form-control" id="message-text" name="messageText"></textarea>
                                    </div>
                                </form>
                            </div>
                            <span className='paragraph'>
                                Please note that this is for website feedback only and should not be used for any Customer Service requests.
                                Such requests cannot and will not be accepted via this system.
                            </span>
                            <div className="modal-footer">
                                <button className="btn btn-success" onClick={sendingMessage} data-bs-dismiss="modal">Send</button>
                            </div>
                        </div>
                    </div>
                </div>}

        </div>

    );
}

export default MenuComponent;

